<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    后海站<br>
站点介绍<br>
后海站位于后海滨路与南山后海中心区的二层商业步道交叉路口下，呈南北走向。车站周围有南山商业中心、深圳湾体育馆海岸城、保利剧院、保利中心、海雅百货，是南山规模最大，客流最集中最多的区域。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:43	00:23	2号线	2分35秒	5分45秒<br>
莲塘	06:01	23:17	2号线	2分35秒	5分45秒<br>
岗厦北	06:15	00:23	11号线	4分钟	6分32秒<br>
碧头	06:35	23:45	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:48	00:23	2号线	4分钟	5分钟<br>
莲塘	06:01	23:17	2号线	4分钟	5分钟<br>
岗厦北	06:15	00:23	11号线	4分34秒	6分钟<br>
碧头	06:35	23:45	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:48	01:13	2号线	4分钟	5分钟<br>
莲塘	06:01	00:17	2号线	4分钟	5分钟<br>
岗厦北	06:15	00:23	11号线	4分37秒	6分钟<br>
碧头	06:35	23:45	11号线	4分37秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口（暂未开通）:<br>
后海滨路东侧、深圳湾体育中心、中业兴融互联网金融服务有限公司<br><br>
D1出入口:<br>
海德二道、后海滨路西侧(北）、南山捐血站、华侨永亨银行前海支行、海岸城购物中心、海岸大厦、深圳联合丽格医疗美容<br><br>
D2出入口:<br>
海德三道、深圳市南山区第二外国语学校、漾日湾畔<br><br>
E出入口:<br>
后海滨路西侧(南）、学府中学、南山书城、观海台、保利剧院、保利文化广场、家乐福、文心六路<br><br>
F出入口:<br>
观海台花园、鹏润达大厦、深圳湾公园<br><br>
G出入口:<br>
中心路西侧、中铁南方总部大厦、海信南方大厦、财富海湾公馆、深圳湾万象城<br><br>
H出入口:<br>
海德三道北侧、深圳湾体育中心、卓越后海中心、深圳湾公园<br><br>
J出入口:<br>
海德三道北侧、滨海大道南侧中国航天科技大厦、南山区第二外国语学校、航天科技广场、A8音乐大厦<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 后海地铁站<br>
M371、M429、M483<br><br>
D2出入口:<br>
公交站名： 后海地铁站<br>
M371、M429、M483<br><br>
E出入口:<br>
公交站名： 海岸城站<br>
19、229、B605、M539、M209、M222、M299、M429、M430、M467、M474、M475、M519、N24、E12<br><br>
E出入口:<br>
公交站名： 海岸城站<br>
19、229、B605、M539、M209、M222、M299、M429、M430、M467、M474、M475、M519、N24、E12<br><br>
G出入口:<br>
公交站名： 卓越后海中心<br>
M299、M467、M429、M474、高峰专线122<br><br>
H出入口:<br>
公交站名： 卓越后海中心<br>
B964、M299、M467、M429、M474、N24<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shiyihaoxian",
          title: "11号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>